import { request } from '../request';

export const cronJobApi = {
  listCronJobs: () => request('/cron/jobs'),

  createCronJob: (spec) =>
    request('/cron/jobs', {
      method: 'POST',
      body: JSON.stringify(spec)
    }),

  getCronJob: (jobId) => request(`/cron/jobs/${encodeURIComponent(jobId)}`),

  replaceCronJob: (jobId, spec) =>
    request(`/cron/jobs/${encodeURIComponent(jobId)}`, {
      method: 'PUT',
      body: JSON.stringify(spec)
    }),

  deleteCronJob: (jobId) =>
    request(`/cron/jobs/${encodeURIComponent(jobId)}`, {
      method: 'DELETE'
    }),

  pauseCronJob: (jobId) =>
    request(`/cron/jobs/${encodeURIComponent(jobId)}/pause`, {
      method: 'POST'
    }),

  resumeCronJob: (jobId) =>
    request(`/cron/jobs/${encodeURIComponent(jobId)}/resume`, {
      method: 'POST'
    }),

  runCronJob: (jobId) =>
    request(`/cron/jobs/${encodeURIComponent(jobId)}/run`, {
      method: 'POST'
    }),

  triggerCronJob: (jobId) =>
    request(`/cron/jobs/${encodeURIComponent(jobId)}/run`, {
      method: 'POST'
    }),

  getCronJobState: (jobId) => request(`/cron/jobs/${encodeURIComponent(jobId)}/state`)
};
